import {
    AG_GRID_LOCALE_EN,
    AG_GRID_LOCALE_FR,
    AG_GRID_LOCALE_ES,
    AG_GRID_LOCALE_BG,
    AG_GRID_LOCALE_BR,
    AG_GRID_LOCALE_CN,
    AG_GRID_LOCALE_CZ,
    AG_GRID_LOCALE_DE,
    AG_GRID_LOCALE_DK,
    AG_GRID_LOCALE_EG,
    AG_GRID_LOCALE_FI,
    AG_GRID_LOCALE_GR,
    AG_GRID_LOCALE_HK,
    AG_GRID_LOCALE_HR,
    AG_GRID_LOCALE_HU,
    AG_GRID_LOCALE_IL,
    AG_GRID_LOCALE_IR,
    AG_GRID_LOCALE_IT,
    AG_GRID_LOCALE_JP,
    AG_GRID_LOCALE_KR,
    AG_GRID_LOCALE_NL,
    AG_GRID_LOCALE_NO,
    AG_GRID_LOCALE_PK,
    AG_GRID_LOCALE_PL,
    AG_GRID_LOCALE_PT,
    AG_GRID_LOCALE_RO,
    AG_GRID_LOCALE_SE,
    AG_GRID_LOCALE_SK,
    AG_GRID_LOCALE_TR,
    AG_GRID_LOCALE_TW,
    AG_GRID_LOCALE_UA,
    AG_GRID_LOCALE_VN,
} from '@ag-grid-community/locale';
import { GridOptions } from 'ag-grid-community';

export const SERVER_SIDE_DEFAULT_GRID_OPTIONS: GridOptions = {
    rowModelType: 'serverSide',
    pagination: true,
    paginationPageSize: 50,
    paginationPageSizeSelector: [20, 30, 50, 100],
    cacheBlockSize: 50,
    suppressMultiSort: true,
    suppressCellFocus: true,
    suppressContextMenu: true,
    // this setting prevents the grid making multiple api calls when updating multiple parts of config
    // at the same time e.g. sort and filter changes together. The AG Grid docs suggest this setting is for
    // scrolling scenarios, however it's a more general debounce setting
    blockLoadDebounceMillis: 100,
};

export interface GroupByOption {
    label: string;
    value: string | null;
}

export interface GroupByConfig {
    name: string;
    label: string;
}

export const AG_GRID_LOCALES: { [key: string]: any } = {
    ar: AG_GRID_LOCALE_EG,
    bg: AG_GRID_LOCALE_BG,
    'zh-HK': AG_GRID_LOCALE_HK,
    'zh-Hans': AG_GRID_LOCALE_CN,
    zh: AG_GRID_LOCALE_CN,
    'zh-TW': AG_GRID_LOCALE_TW,
    hr: AG_GRID_LOCALE_HR,
    cs: AG_GRID_LOCALE_CZ,
    da: AG_GRID_LOCALE_DK,
    nl: AG_GRID_LOCALE_NL,
    fi: AG_GRID_LOCALE_FI,
    fr: AG_GRID_LOCALE_FR,
    de: AG_GRID_LOCALE_DE,
    el: AG_GRID_LOCALE_GR,
    he: AG_GRID_LOCALE_IL,
    hu: AG_GRID_LOCALE_HU,
    it: AG_GRID_LOCALE_IT,
    ja: AG_GRID_LOCALE_JP,
    ko: AG_GRID_LOCALE_KR,
    nb: AG_GRID_LOCALE_NO,
    fa: AG_GRID_LOCALE_IR,
    pl: AG_GRID_LOCALE_PL,
    pt: AG_GRID_LOCALE_PT,
    'pt-BR': AG_GRID_LOCALE_BR,
    ro: AG_GRID_LOCALE_RO,
    sk: AG_GRID_LOCALE_SK,
    es: AG_GRID_LOCALE_ES,
    sv: AG_GRID_LOCALE_SE,
    tr: AG_GRID_LOCALE_TR,
    uk: AG_GRID_LOCALE_UA,
    ur: AG_GRID_LOCALE_PK,
    vi: AG_GRID_LOCALE_VN,
    en: AG_GRID_LOCALE_EN,
};
